module.exports = __webpack_public_path__ + "static/media/Slack.0782072f.svg";